'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = require('./store');

var _event = require('./event');

var _event2 = _interopRequireDefault(_event);

var _util = require('./util');

var _cache = require('./cache');

var _cache2 = _interopRequireDefault(_cache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * model请求缓存部分处理
 * Created by spring on 2018/9/5.
 */
var store = new _store.Store('requestQueue');

/**
 * 获取当前正在发送的请求信息
 * @param urlKey url生成的缓存key
 * @returns {*}
 */
var get = function get(urlKey) {
  return store.get(urlKey);
};

/**
 * 把请求push到合并后的栈中，等待第一个请求返回
 * @param urlKey url生成的缓存key
 */
var push = function push(urlKey) {
  store.set(urlKey, {
    isRequesting: true,
    timestamp: (0, _util.getTimestamp)()
  });

  // 定时清除，以防请求失败后，无法清除上一次请求状态
  window.setTimeout(function () {
    console.log('request merge clear status', urlKey);
    store.set(urlKey, null);
  }, 5000);

  return true;
};

/**
 * 第一个请求返回后，把合并栈中的所有请求返回
 * @param urlKey url生成的缓存key
 * @param isSuccess 请求是否成功
 * @param data 成功后的数据
 */
var pop = function pop(urlKey, isSuccess, data) {
  // 通过事件通知到合并栈中的请求返回
  _event2.default.emit({
    type: urlKey,
    rsp: {
      isSuccess: isSuccess,
      data: data
    }
  });

  store.set(urlKey, null);

  console.log('request merge remove', urlKey);
};

/**
 * 合并相同请求
 * @param url 接口地址
 * @param params 参数
 * @returns {*}
 */
var merge = function merge(url, params) {
  var urlKey = (0, _util.encode)((0, _util.toUrlWithParams)(url, params));

  var request = get(urlKey);
  console.log('request merge start', url, JSON.stringify(request));

  if (!request) {
    push(urlKey);
    console.log('request merge first', url);
    return false;
  }
  // 同样的接口正在请求中，未返回
  if (request.isRequesting) {
    console.log('request merge success', url);
    // 合并栈先返回promise，等待第一个请求返回后 通过事件触发 resolve

    return $.Deferred(function (defer) {
      console.log('request merge event bind ');
      _event2.default.on(urlKey, function (ret) {
        console.log('request merge resolve', urlKey, ret);
        return ret.rsp.isSuccess ? defer.resolve(ret.rsp.data) : defer.reject(ret.rsp.data);
      });
    });
  }if ((0, _util.getTimestamp)() - request.timestamp < 15) {
    // 如果第一个请求已返回，但是15之内，使用缓存返回
    var cache = _cache2.default.get(url, params);
    console.log('request merge from cache', cache);
    return cache ? cache.resolve(function (data) {
      return data;
    }) : cache.reject(false);
  }
  return false; // 合并请求失败，直接发送请求
};

exports.default = {
  merge: merge,
  remove: function remove(url, params, isSuccess, data) {
    var urlKey = (0, _util.encode)((0, _util.toUrlWithParams)(url, params));

    pop(urlKey, isSuccess, data);
  }
};